import { render, staticRenderFns } from "./UcProjectSelector.yaml?vue&type=template&id=14bb7bc6&component"
import script from "./UcProjectSelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcProjectSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports